module.exports = __webpack_public_path__ + "static/media/police.d0289dc0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/police.png
// module id = 575
// module chunks = 27